import { BeaconSnapshot } from '@/api';
import { createContext } from 'react';

export type TaskBeaconSnapshotContextData = {
    readonly beacons: BeaconSnapshot[];
    readonly updatedAt: Date | null;
    readonly updatedAtStr: string | null;
};

export const TaskBeaconSnapshotContext = createContext<
    TaskBeaconSnapshotContextData | undefined
>(undefined);
